module.exports = __webpack_public_path__ + "web_static/img/header_animation.4c2b0459.gif";